module.exports = __webpack_public_path__ + "img/Image_logo_4.e90a8785.jpg";